import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';

import { Container, Grid, IconButton, Paper, Stack } from '@mui/material';
export default function History() {


    const { getHistoryOfUser } = useContext(AuthContext);

    const [meetings, setMeetings] = useState([])


    const routeTo = useNavigate();

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const history = await getHistoryOfUser();
                setMeetings(history);
            } catch {
                // IMPLEMENT SNACKBAR
            }
        }

        fetchHistory();
    }, [getHistoryOfUser])

    let formatDate = (dateString) => {

        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear();

        return `${day}/${month}/${year}`
    }

    return (
        <Box className="historyShell">
            <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        <IconButton onClick={() => { routeTo("/home") }} aria-label="Go home" sx={{ border: '1px solid rgba(255,255,255,0.1)', color: '#ffffff' }}>
                            <HomeIcon />
                        </IconButton>
                        <Box>
                            <Typography variant="h4" fontWeight={400} sx={{ color: '#ffffff' }}>
                                Meeting history
                            </Typography>
                            <Typography color="text.secondary" variant="body2">
                                Your recent rooms, with dates for quick recall.
                            </Typography>
                        </Box>
                    </Stack>

                    <Button variant="contained" onClick={() => routeTo("/home")} sx={{ py: 1, px: 3, borderRadius: 2 }}>
                        Back to home
                    </Button>
                </Stack>

                {meetings.length === 0 ? (
                    <Paper elevation={10} className="historyEmptyCard">
                        <Grid container spacing={4} alignItems="center">
                            <Grid item xs={12} md={6}>
                                <Typography variant="h5" fontWeight={500} gutterBottom sx={{ color: '#ffffff', mb: 1 }}>
                                    No meetings yet
                                </Typography>
                                <Typography color="text.secondary" sx={{ mb: 3 }}>
                                    When you join a room from Home, it will show up here automatically.
                                </Typography>
                                <Button variant="contained" onClick={() => routeTo("/home")} sx={{ py: 1.2, px: 3, borderRadius: 2 }}>
                                    Join your first meeting
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={6} sx={{ textAlign: { xs: "center", md: "right" } }}>
                                <img className="historyEmptyArt" src="/empty-history.svg" alt="Empty history" />
                            </Grid>
                        </Grid>
                    </Paper>
                ) : (
                    <Grid container spacing={2.5}>
                        {meetings.map((e, i) => (
                            <Grid item xs={12} sm={6} md={4} key={i}>
                                <Card variant="outlined" className="historyCard" sx={{ border: '1px solid rgba(255,255,255,0.08)' }}>
                                    <CardContent sx={{ p: 3 }}>
                                        <Typography variant="overline" color="primary" sx={{ letterSpacing: '0.05em', fontWeight: 600 }}>
                                            Meeting code
                                        </Typography>
                                        <Typography variant="h5" fontWeight={500} sx={{ mt: 0.5, mb: 1.5, color: '#ffffff' }}>
                                            {e.meetingCode}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            Joined on {formatDate(e.date)}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Container>
        </Box>
    );
}
